import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  
    apiKey: "AIzaSyAuMXaos5p_ESuOidiN8oLJko4csZ83Xfs",
    authDomain: "smart-money-vzla.firebaseapp.com",
    projectId: "smart-money-vzla",
    storageBucket: "smart-money-vzla.firebasestorage.app",
    messagingSenderId: "574294625830",
    appId: "1:574294625830:web:f2a375479ff543797520e7",
    measurementId: "G-XYMXWC64TP"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
